import { render } from "./BrandFounders.vue?vue&type=template&id=1ca736de&scoped=true"
import script from "./BrandFounders.vue?vue&type=script&lang=js"
export * from "./BrandFounders.vue?vue&type=script&lang=js"

import "./BrandFounders.vue?vue&type=style&index=0&id=1ca736de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca736de"]])

export default __exports__